module.exports = __webpack_public_path__ + "img/beam-body-3.a63d2fda.png";